/** Ошибки, которые даёт сам клиент, и коды сервера, на которые реагируют системные модули */
export enum EnumApiError {
  NETWORK_ERROR = 'network_error',
  BAD_RESPONSE = 'bad_response',
  UNAUTHORIZED = 'unauthorized',
  DEVICE_NOT_TRUSTED = 'device_not_trusted',
  INVALID_PIN = 'invalid_pin',
  PIN_REQUIRED = 'pin_required',
  LOGIN_LOCKED = 'login_locked',
  PIN_CHANGE_REQUIRED = 'pin_change_required',
}
